import React from "react";
import Chart from "react-apexcharts";
import { COLOR_ROTACION_PREVIO, COLOR_ROTACION_ACTUAL } from "./constants";
import { formatNumber } from "./utils";

export default function GraficoRotacionInventario(props) {
    const meses = props.meses || [];
    const valores = props.valores || [];
    // Con "distributed" cada barra toma su color del arreglo: solo la ultima
    // (mes actual) va resaltada.
    const colores = meses.map((_, indice) => (indice === meses.length - 1 ? COLOR_ROTACION_ACTUAL : COLOR_ROTACION_PREVIO));
    // Con rotaciones bajas (p. ej. 0.15) sin decimales el eje repetiria "0".
    const maximo = Math.max(0, ...valores);
    const decimalesEje = maximo < 1 ? 2 : maximo < 10 ? 1 : 0;

    const options = {
        chart: {
            type: "bar",
            toolbar: { show: false },
        },
        plotOptions: {
            bar: {
                columnWidth: "50%",
                borderRadius: 2,
                distributed: true,
            },
        },
        colors: colores,
        dataLabels: { enabled: false },
        legend: { show: false },
        xaxis: {
            categories: meses,
            axisBorder: { show: false },
            axisTicks: { show: false },
        },
        yaxis: {
            min: 0,
            forceNiceScale: true,
            labels: { formatter: (val) => formatNumber(val, decimalesEje) },
        },
        grid: { borderColor: "#eef0f2", strokeDashArray: 3 },
        tooltip: {
            y: {
                formatter: (val) => `${formatNumber(val, 2)} veces`,
                title: { formatter: () => "Rotación:" },
            },
        },
    };

    return (
        <Chart
            key={`${colores.join("|")}-${decimalesEje}`}
            options={options}
            series={[{ name: "Rotación", data: valores }]}
            type="bar"
            height={250}
        />
    );
}
